<p class="laft-form--title">Datos del beneficiario y origen de los fondos</p>
<form class="laft-form" [formGroup]="beneficiaryDataForm">
  <app-section-message
    title="¿Qué es el Beneficiario Final?"
    text="Un beneficiario final es la persona natural que realmente es dueña o controla una empresa o fondos, incluso si aparece a través de otras personas o empresas."
    type="warning"
  ></app-section-message>
  <div>
    <lib-file-upload
      label="Reporte Tributario"
      [iconUpload]="true"
      internalSpacing="s"
      formats="image+pdf"
      [getFileName]="true"
      [initialLabel]="'Subir Reporte Tributario'"
      [loadedLabel]="taxReportFileName"
      formControlName="taxReport"
      (onFileLoaded)="onTaxReportFileLoaded($event)"
      [default]="taxReportDataUrl"
    >
    </lib-file-upload>
    <p class="error-message" *ngIf="taxReportErrorMessage">{{ taxReportErrorMessage }}</p>
  </div>
  <section class="laft-form--group" *ngIf="isTaxReportValid">
    <p class="laft-form--group-title">Accionistas con 10% o más de participación</p>
    <div class="laft-form--representatives" formArrayName="shareHolders">
      <div
        *ngFor="let representative of shareHolders.controls; let i = index"
        [formGroupName]="i"
        class="laft-form--representatives-group"
      >
        <app-input formControlName="fullName" label="Nombres y apellidos"></app-input>
        <div class="form-group-2-grid gap-24">
          <app-select
            formControlName="documentType"
            defaultOption="national id"
            [options]="legalRepresentativeIdTypeOptions"
            valueField="value"
            textField="text"
            label="Tipo de documento"
          ></app-select>
          <app-input formControlName="documentNumber" label="Número de documento"></app-input>
        </div>
      </div>
    </div>
    <button type="button" class="laft-form--representatives-button" (click)="addLegalRepresentative()">
      Añadir
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
          fill="#0256FF"
        />
      </svg>
    </button>
  </section>
  <section
    class="laft-form--group"
    [class.laft-form--group-disabled]="beneficiaryDataForm.get('isBeneficiary').disabled"
  >
    <p class="laft-form--group-title u-mb-4">¿Los accionistas son los beneficiarios finales?</p>
    <mat-radio-group class="laft-form--group-radio-button" formControlName="isBeneficiary">
      <mat-radio-button [value]="false" [disabled]="beneficiaryDataForm.get('isBeneficiary').disabled"
        ><span class="laft-form-option">No</span></mat-radio-button
      >
      <mat-radio-button [value]="true" [disabled]="beneficiaryDataForm.get('isBeneficiary').disabled"
        ><span class="laft-form-option">Sí</span></mat-radio-button
      >
    </mat-radio-group>
    <div class="representative-form--container" *ngIf="!beneficiaryDataForm.get('isBeneficiary').value">
      <div class="representative-form--person-container">
        <p class="representative-form--title">¿A quién representa?</p>
        <mat-radio-group formControlName="beneficiaryRepresentativeType">
          <mat-radio-button value="persona_natural">Persona natural</mat-radio-button>
          <mat-radio-button value="persona_juridica">Persona jurídica o ente jurídico</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="representative-form--natural-container" *ngIf="isPersonalNatural">
        <div class="form-group">
          <app-input
            formControlName="beneficiaryPersonName"
            label="Nombres y apellidos del representado"
            maxlength="100"
          ></app-input>
          <div class="form-group-2-grid gap-24">
            <app-select
              formControlName="beneficiaryPersonDocumentType"
              defaultOption="national id"
              [options]="idTypeOptions"
              valueField="value"
              textField="text"
              label="Tipo de documento del representado"
            ></app-select>
            <app-input
              formControlName="beneficiaryPersonDocumentNumber"
              label="Número de documento del representado"
            ></app-input>
          </div>
        </div>
        <div class="representative-form--person-radio-button">
          <p class="representative-form--title">Poder por:</p>
          <mat-radio-group formControlName="beneficiaryPersonPowerType">
            <mat-radio-button value="escritura_publica">Escritura pública</mat-radio-button>
            <mat-radio-button value="mandato">Mandato</mat-radio-button>
          </mat-radio-group>
        </div>
        <lib-file-upload
          [iconUpload]="true"
          internalSpacing="s"
          formats="image+pdf"
          [getFileName]="true"
          label="Documento de poder"
          initialLabel="Documento de poder"
          formControlName="beneficiaryPersonDocument"
        ></lib-file-upload>
        <div class="representative-form--person-pep">
          <p class="representative-form--title">¿Es o ha sido una persona políticamente expuesta?</p>
          <mat-radio-group
            formControlName="isBeneficiaryPersonPep"
            class="representative-form--person-pep-radio-button"
          >
            <mat-radio-button [value]="true">Sí</mat-radio-button>
            <mat-radio-button [value]="false">No</mat-radio-button>
          </mat-radio-group>
          <div class="form-group-2-grid gap-24" *ngIf="isBeneficiaryPersonPep">
            <app-input formControlName="beneficiaryPersonCharge" label="Cargo" maxlength="100"></app-input>
            <app-input
              formControlName="beneficiaryPersonInstitution"
              label="Nombre de la institución"
              maxlength="100"
            ></app-input>
          </div>
        </div>
      </div>
      <div class="representative-form--business-container" *ngIf="!isPersonalNatural">
        <div class="form-group-2-grid gap-16">
          <app-input formControlName="beneficiaryBusinessName" label="Denominación o razón social"></app-input>
          <app-input formControlName="beneficiaryRuc" label="Número de RUC"></app-input>
        </div>
        <div class="representative-form--business-radio-button">
          <p class="representative-form--title">Poder por:</p>
          <mat-radio-group formControlName="beneficiaryPowerType">
            <mat-radio-button value="acta">Acta</mat-radio-button>
            <mat-radio-button value="escritura_publica">Escritura pública</mat-radio-button>
            <mat-radio-button value="mandato">Mandato</mat-radio-button>
          </mat-radio-group>
        </div>
        <lib-file-upload
          [iconUpload]="true"
          internalSpacing="s"
          formats="image+pdf"
          [getFileName]="true"
          label="Documento de poder"
          initialLabel="Documento de poder"
          formControlName="beneficiaryDocument"
        ></lib-file-upload>
      </div>
    </div>
  </section>

  <section class="laft-form--group" [class.laft-form--group-disabled]="beneficiaryDataForm.get('fundsOrigin').disabled">
    <p class="laft-form--group-title u-mb-4">Sobre los fondos</p>
    <div class="form-group-2 u-mb-1">
      <app-select
        class="laft-form--block-width"
        formControlName="fundsOrigin"
        [options]="fundsOriginOptions"
        valueField="value"
        textField="text"
        label="Origen de los fondos"
        [isDisabled]="beneficiaryDataForm.get('fundsOrigin').disabled"
      ></app-select>
      <app-input
        class="laft-form--block-width"
        *ngIf="beneficiaryDataForm.get('fundsOrigin').value === 'other'"
        formControlName="fundsOriginOtherOption"
        label="Origen de los fondos"
        [isDisabled]="beneficiaryDataForm.get('fundsOriginOtherOption').disabled"
      ></app-input>
    </div>

    <div class="form-group-2">
      <app-select
        class="laft-form--block-width"
        formControlName="fundsOriginLocation"
        [options]="fundsOriginLocationOptions"
        valueField="value"
        textField="text"
        label="Lugar de origen de los fondos"
        [isDisabled]="beneficiaryDataForm.get('fundsOriginLocation').disabled"
      ></app-select>
      <app-input
        class="laft-form--block-width"
        *ngIf="beneficiaryDataForm.get('fundsOriginLocation').value === 'other'"
        formControlName="fundsOriginLocationOtherOption"
        label="Lugar de origen de los fondos"
        [isDisabled]="beneficiaryDataForm.get('fundsOriginLocationOtherOption').disabled"
      ></app-input>
    </div>
  </section>

  <div class="laft-form--actions">
    <button type="button" class="laft-form--btn-submit" (click)="onContinue()">Continuar</button>
  </div>
</form>
